import { useFieldArrayOf } from '@framework/form/form/relations/useFieldsArrayOf.ts';
import { Button, Typography } from 'antd';
import { Datatype } from '../../../../../expressions/datatype/Datatype.ts';
import { AdvancedSelectColumnConfig } from './AdvancedSelectColumnConfig.tsx';

export interface IAdvancedSelectTableConfigFormFormProps {}

/**
 * Form di configurazione della tabella per la selezione singola avanzata.
 */
export function AdvancedSelectTableConfigForm(
  props: IAdvancedSelectTableConfigFormFormProps,
) {
  const { fields, append, remove } = useFieldArrayOf({
    name: 'columns',
    keyName: '_uid',
  });

  return (
    <div style={{ paddingTop: '8px', paddingBottom: '16px' }}>
      <Typography.Text type="secondary">
        Configura le colonne della tabella che verrà visualizzata. Le colonne
        verranno visualizzate nell&apos;ordine in cui vengono configurate.
      </Typography.Text>
      <div style={{ paddingTop: '8px' }}>
        {fields?.map((c, i) => (
          <AdvancedSelectColumnConfig
            key={c._uid}
            index={i}
            onDelete={() => remove(i)}
          />
        ))}
      </div>
      <Button
        onClick={() => {
          const newColumnIndex = (fields?.length ?? 0) + 1;
          append({
            id: `colonna_${newColumnIndex}`,
            label: '',
            type: Datatype.String,
          });
        }}
      >
        Aggiungi colonna
      </Button>
    </div>
  );
}
